import React from "react";
import {
  HiOutlinePencil,
  HiOutlineTrash,
  HiOutlineXCircle,
  HiXCircle,
} from "react-icons/hi";

const WarehouseDetailsModal = ({
  warehouses,
  onClose,
  onEditWarehouse,
  onDeleteWarehouse,
}) => {
  return (
    <div className="fixed inset-[-30px] bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-2 w-9/12 sm:w-[90%] max-w-6xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-lg sm:text-xl text-red-600 font-semibold">
            Warehouse Details
          </h3>
          <button
            onClick={onClose}
            className="text-gray-500  rounded-md hover:text-gray-600 transition-all duration-300 ease-in-out"
          >
            <HiOutlineXCircle size={20} />
          </button>
        </div>
        <div className="overflow-x-auto max-w-[100vw] rounded-lg border border-gray-300 shadow-md">
          <table className="min-w-full table-auto rounded-lg overflow-scroll shadow-md border-spacing-0 border-collapse">
            <thead className="bg-gray-700 text-white">
              <tr>
                <td className="p-2 font-normal tracking-wide">#</td>
                <th className="p-2 font-normal tracking-wide text-left">
                  Warehouse Name
                </th>
                <th className="p-2 font-normal tracking-wide text-left">
                  Contact Person
                </th>
                <th
                  className="p-2 font-normal tracking-wide text-left"
                  title=" Warehouse Contact Mobile NO."
                >
                  Mob. No.
                </th>
                <th className="p-2 font-normal tracking-wide text-left">
                  Group Id.
                </th>
                <th className="p-2 font-normal tracking-wide text-left">
                  Address
                </th>
                <th className="p-2 font-normal tracking-wide text-left min-w-16">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white">
              {warehouses.map((warehouse, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 border-b divide-x divide-gray-200 border-gray-200"
                >
                  <td className="px-2 py-1">{index + 1}</td>
                  <td className="px-2 py-1">
                    {warehouse.warehouseName.charAt(0).toUpperCase() +
                      warehouse.warehouseName.slice(1).toLowerCase()}
                  </td>
                  <td className="px-2 py-1">{warehouse.contactPerson}</td>
                  <td className="px-2 py-1">{warehouse.mobileNo}</td>
                  <td className="px-2 py-1">{warehouse.wagroupId}</td>
                  <td className="px-2 py-1">{warehouse.address}</td>
                  <td className="px-2 py-1 space-x-2">
                    <button
                      onClick={() => onEditWarehouse(warehouse)}
                      className="text-blue-500 hover:text-blue-700"
                    >
                      <HiOutlinePencil size={16} />
                    </button>
                    <button
                      onClick={() => onDeleteWarehouse(warehouse._id)}
                      className="text-red-500 hover:text-red-700"
                    >
                      <HiOutlineTrash size={16} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default WarehouseDetailsModal;
